import { Base } from "./base";
import { Address, AddressDTO } from "./address";
import { AbstractControl, UntypedFormGroup } from "@angular/forms";
import { Tenants } from "./tenants";

export interface CustomersFilters{
  filter?: string;
  onlyCurrentTenant?: boolean;
  defaultTenantId?: number;
}

export interface CustomerDTO {
  id?: number;
  name?: string;
  surname?: string;
  phone?: string;
  email?: string;
  addresses?: AddressDTO[];
  fidelity_card_points?: number;
  active?: number;
  notes?: string;
  default_tenant_id?: number;
  tenant?: Tenants;
}
export class Customer extends Base {
   name: string;
   surname: string;
   phone: string;
   email: string;
   addresses: Array<Address>;
   fidelityCardPoints: number;
   active: boolean;
   notes: string;
   defaultTenantId: number;
   tenant: Tenants;
   user_roles: string[];

  constructor(source: CustomerDTO) {
    super(source);
    if (source) {
      this.name = source.name;
      this.surname = source.surname;
      this.phone = source.phone;
      this.email = source.email;
      this.notes = source.notes;
      this.fidelityCardPoints = source.fidelity_card_points;
      this.tenant = source.tenant;
      this.active = source.active === 1 ? true : false;
      this.addresses = new Array<Address>();
      this.defaultTenantId = source.default_tenant_id;
      if (source.addresses) {
        source.addresses.forEach(address => {
          this.addresses.push(new Address(address));
        });
      }
    }
  }

  toDTO(excludes?: string[]): CustomerDTO {
    let result: CustomerDTO = <CustomerDTO>super.toDTO(); {
      result.id = this.id,
      result.name = this.name,
      result.surname = this.surname,
      result.phone = this.phone,
      result.email = this.email,
      result.fidelity_card_points = this.fidelityCardPoints,
      result.active =  this.active ? 1 : 0,
      result.notes = this.notes,
      result.default_tenant_id = this.defaultTenantId,
      result.tenant = this.tenant
    };
    if (this.addresses && !this.isToBeExcluded("addresses", excludes)) {
      result.addresses = [];
      this.addresses.forEach(address => {
        result.addresses.push(address.toDTO());
      });
    }
    return result;
  }

  static fromFormGroup(formGroup: AbstractControl, original?: Customer) {
    const formModel = formGroup.value;
    let customer: Customer = new Customer(null);
    customer.name = formModel.name;
    customer.surname = formModel.surname;
    customer.email = formModel.email;
    customer.phone = formModel.phone;
    customer.notes = formModel.notes;
    customer.fidelityCardPoints = formModel.fidelityCardPoints;
    customer.active = formModel.active;
    customer.defaultTenantId = formModel.defaultTenantId;


    if (original) {
      customer.id = original.id;
    }

    return customer;
  }

}
